type GrupoTributario = {
    codigo:number|EnumGrupoTributario;
    nome:string;
    ativo:boolean;
    dataCriacao:Date;
}
export enum EnumGrupoTributario {
    ClassificacaoFiscal = 1,
    Empresa,
    Servico
}
export default GrupoTributario;